export function trimHttp(url) {
    return url ? url.replace(/^http(s)?:/, '') : '';
}